import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import AprovarSerasa from '../pages/comercial/aprovarSerasa';
import CreateDocuments from '../pages/comercial/criarDocumentos';
import EmailVerificacao from '../pages/comercial/emailVerificacao';
import GerarProposta from '../pages/comercial/gerarProposta';
import NotificarCliente from '../pages/comercial/notificarCliente';

const RouteComercial = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='Comercial'/>}>
                <Route path='notificarCliente' element={<NotificarCliente/>}/>
                <Route path='emailVerificacao' element={<EmailVerificacao/>}/>
                <Route path='aprovarSerasa' element={<AprovarSerasa/>}/>
                <Route path='createDocuments' element={<CreateDocuments/>}/>
                <Route path='gerarProposta' element={<GerarProposta/>}/>
            </Route>
        </Routes>
    );
};

export default RouteComercial;
